/**
 * Implements some of LMS Landing Page APIs
 */

window.LMSFollowUpAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    self.TYPES = {
        CONTACT_US: "CONTACT_US",
        EXISTING: "EXISTING",
        STRATEGIC: "STRATEGIC"
    };

    self.submitFollowUpRequest = function (data) {
        var deferred = $q.defer();

        _protected.request('public/lms/brands/pricing/follow_up', 'POST', data)
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

});
